export const MANAGERS_OVERRIDE_STATUS_ON = "ManagersOverrideStatusOn";
export const MANAGERS_OVERRIDE_STATUS_DISABLE_PENDING =
  "ManagersOverrideStatusDisablePending";
export const MANAGERS_OVERRIDE_STATUS_OFF = "ManagersOverrideStatusOff";
